import { useEffect, useRef } from 'react'

import { useLocation } from 'react-router-dom'
import SmoothScrollbar from 'smooth-scrollbar'

/**
 * ScrollToTop component that scrolls the window to the top when navigating
 * from the dashboard to other pages. This component should be placed near
 * the root of your component tree, typically just inside your Router.
 */
const ScrollToTop: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { pathname, search } = useLocation()
  const prevPathRef = useRef<string | null>(null)

  useEffect(() => {
    if (prevPathRef.current !== '/' || pathname === '/') return

    const scrollbar = document.getElementsByClassName('scrollbar')[0] as HTMLElement
    const smoothScroll = SmoothScrollbar.get(scrollbar)

    if (!scrollbar || !smoothScroll) return console.warn('Could not find scrollbar or smoothScroll')

    smoothScroll.setPosition(0, 0)
    prevPathRef.current = pathname
  }, [pathname, search])

  return <>{children}</>
}

export default ScrollToTop
